import app from 'app';
import { mapGetters, mapState } from 'vuex';

export default {
  props: {
    context: {
      type: String,
      required: false,
      default: 'dashboard',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    showExpandCollapse: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  name: 'MastheadMenu',

  data() {
    return {
      apiUrl: serverProfile.apiUrl,
      show: {
        devLinks:
          app.rootStore.getters['user/box'].isDev() ||
          (app.rootStore.getters['user/box'].isTest() &&
            app.rootStore.getters['user/type'].WOCHIT_INTERNAL),
        importExport: app.rootStore.getters['user/type'].WOCHIT_INTERNAL,
        story: this.$props.context === 'story',
        invite: app.rootStore.getters['user/hasPermission']('USER_INVITATION'),
      },
      isExpend: false,
    };
  },

  created() {
    // In the editor, resolve the open story's version family so the menu can
    // show the "Version History" entry + count (store dedupes the request).
    if (this.$props.context === 'story' && this.openStoryId) {
      this.$store
        .dispatch('storyVersions/FETCH_VERSIONS', {
          storyId: this.openStoryId,
        })
        .catch(() => {});
    }
  },

  computed: {
    ...mapState({
      isTemplate: (state) => state.story?.isTemplate,
    }),
    ...mapGetters(['isUserCanCreateStories']),
    ...mapGetters('timemachine', ['shouldShow_TrackLayerAudio']),
    ...mapGetters('user', ['isImpededTemplatizer']),
    ...mapGetters('storyVersions', ['groupByStoryId']),

    isStoryboard() {
      return this.$props.context === 'story' ? this.isTemplate : false;
    },

    openStoryId() {
      return this.$store.state.story ? this.$store.state.story.id : null;
    },

    versionGroup() {
      return this.openStoryId ? this.groupByStoryId(this.openStoryId) : null;
    },

    versionsCount() {
      return this.versionGroup ? this.versionGroup.versions.length : 0;
    },

    // Keep the badge one/two digits - cap the display at "99+".
    versionsCountLabel() {
      return this.versionsCount > 99 ? '99+' : String(this.versionsCount);
    },

    showVersionHistory() {
      return this.show.story && this.versionsCount > 1;
    },
  },

  methods: {
    justDoIt(e) {
      if (e) {
        const data = e.currentTarget.dataset;
        if (data.trigger) {
          e.preventDefault();
          app.trigger(data.trigger, data.triggerData || e);
        } else if (data.goto) {
          e.preventDefault();
          window.open(data.goto, '_blank');
        }
      }

      this.$children[0].onToggle();
    },

    $_openSupport(e, path) {
      app.openSupportTab({ path });
    },

    $_openKalturaSupport() {
      window.open('https://knowledge.kaltura.com/help/wochit', '_blank');
    },

    toggle() {
      this.isExpend = !this.isExpend;
    },

    shouldShow(show) {
      return this.showExpandCollapse ? show && this.isExpend : show;
    },
  },
};
